import styled from "styled-components/macro";
import { Card } from "../../../../components";
import { media } from "../../../../utils";

export const RegionDetails = styled(Card)`
  text-align: center;
  padding: 16px 0;
  width: 100%;
  max-width: 375px;
  display: ${({ show }) => (show ? "block" : "none")};
  -webkit-transition: display 300ms ease;
  -moz-transition: display 300ms ease;
  -o-transition: display 300ms ease;
  -ms-transition: display 300ms ease;
  transition: display 300ms ease;
  color: ${({ theme }) => theme.color.brandPrimary.light};
  & .Card__Body {
    padding-bottom: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.color.brandPrimary.light};
  }

  & .Card__Footer {
    padding-top: 16px;
  }
`;

export const Regiao = styled.path`
  cursor: pointer;
  fill: ${({ theme, active }) =>
    active
      ? theme.color.brandSecondary.medium
      : theme.color.brandPrimary.light};
`;

export const MapaImage = styled.svg`
  width: 100%;
  max-width: 450px;
  color: ${({ theme }) => theme.color.neutral["08"]};
`;

export const MapaPremiosContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MapaPremiosContainer = styled.div`
  ${media.lg()} {
    position: relative;

    ${RegionDetails} {
      position: absolute;
      max-width: 300px;

      & .Card__Footer {
        padding-top: 16px;
        border-bottom: none;
      }

      &.norte {
        top: 50px;
        left: 50px;
        text-align: left;
      }

      &.centro-oeste {
        top: 248px;
        left: 234px;
        text-align: left;
      }

      &.sul {
        top: 344px;
        left: 250px;
        text-align: left;
      }

      &.sudeste {
        top: 246px;
        right: 131px;
        text-align: right;
      }

      &.nordeste {
        top: 140px;
        right: 85px;
        text-align: right;
      }
    }
  }
`;

export const ContainerFormulario = styled.div`
  margin-bottom: 0;
`;

export const ResultadoContainer = styled.div`
  padding-top: 16px;
`;
